import {email, required} from 'vuelidate/lib/validators'

const form = {
  email: {
    size: 0,
    type: 'email',
    name: 'email',
    placeholder: 'E-mail',
    value: null,
    mask: false,
    loading: false,
    errors: {
      email: 'digite um e-mail válido'
    }
  }
}
const validations = {
  email: {
    value: {
      required,
      email
    }
  }
}

export {
  form,
  validations
}
